import { render, staticRenderFns } from "./shop.view.vue?vue&type=template&id=440fa2aa&scoped=true"
import script from "./shop.view.vue?vue&type=script&lang=js"
export * from "./shop.view.vue?vue&type=script&lang=js"
import style0 from "./shop.view.vue?vue&type=style&index=0&id=440fa2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fa2aa",
  null
  
)

export default component.exports